import { PostSearch } from '@/type';
import api from '../../API';

export function create(clientId: number, keywords: string[]): Promise<PostSearch> {
  return api
    .post(`clients/${clientId}/post-searches`, { keywords })
    .then(response => response.data);
}

export function edit(id: number, keywords: string[]): Promise<PostSearch> {
  return api
    .put(`post-searches/${id}`, { keywords })
    .then(res => res.data);
}

export function remove(id: number): Promise<void> {
  return api.delete(`post-searches/${id}`);
}
